import React, { useEffect, useState } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { is_valid_emoji_id } from '@tari-labs/emojis-wasm-default';
import { YatPageVersion } from '@/client/common/structs/yatPage/yat-page';
import { getYatPageDetails } from '@/store/actions/yat-page';

import { useAppDispatch, useAppSelector } from '@/hooks';
import { PrototypePage } from '@/pages/Prototype';
import YatPage from '@/pages/YatPage';
import config from '@/config';
import { PathParams } from '@/routes/types';

declare global {
    interface Window {
        YAT_PV: YatPageVersion | null;
    }
}
/**
 * Wrapper component responsible for detecting the Yat Page version and render appropriate public yat page
 * @constructor
 */
const PublicYatPage = () => {
    const dispatch = useAppDispatch();
    const { [PathParams.Yat]: yat } = useParams();
    const { yatPageVersion } = useAppSelector((state) => state.yatPage);
    const [pageVersion, setPageVersion] = useState<YatPageVersion | null>(window.YAT_PV);

    useEffect(() => {
        if (yat && is_valid_emoji_id(yat, config.maxLengthYat)) dispatch(getYatPageDetails(yat as string));
    }, [dispatch, yat]);

    useEffect(() => {
        setPageVersion(yatPageVersion ?? window.YAT_PV);
    }, [yatPageVersion]);

    if (!yat || !is_valid_emoji_id(yat, config.maxLengthYat)) {
        return <Navigate to="/404" replace />;
    }

    if (pageVersion === YatPageVersion.V1 || pageVersion === YatPageVersion.NOT_FOUND) {
        return <YatPage />;
    }

    return <PrototypePage isPublic />;
};

export default PublicYatPage;
